import * as React from "react";
import { Clock } from "lucide-react";

import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

export interface TimePickerProps {
  time: string;
  setTime: (time: string) => void;
  disabled?: boolean;
  className?: string;
}

export function TimePicker({
  time,
  setTime,
  disabled,
  className,
}: TimePickerProps) {
  const [isOpen, setIsOpen] = React.useState(false);

  const handleTimeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setTime(e.target.value);
  };

  const displayTime = time || "--:--";

  return (
    <div className={cn("grid gap-2", className)}>
      <Popover open={isOpen} onOpenChange={setIsOpen}>
        <PopoverTrigger asChild>
          <Button
            id="time"
            variant={"outline"}
            className={cn(
              "w-full justify-start text-left font-normal",
              !time && "text-muted-foreground"
            )}
            disabled={disabled}
          >
            <Clock className="mr-2 h-4 w-4" />
            <span>{displayTime}</span>
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-4" align="start">
          <div className="flex flex-col space-y-2">
            <p className="text-sm font-medium">Seleccionar hora</p>
            <Input
              type="time"
              value={time}
              onChange={handleTimeChange}
              className="w-full"
              disabled={disabled}
              autoFocus
            />
          </div>
        </PopoverContent>
      </Popover>
    </div>
  );
} 